import React from 'react'
import PropTypes from 'prop-types'
import Measure from 'react-measure'
import { ContextMenu, MenuItem } from 'react-contextmenu'
import FormQuestionSlide from '../slides/FormQuestionSlide'
import QuestionListPanel from './QuestionListPanel'
import EditorTopBar from './EditorTopBar'
import EditorToolbar from './EditorToolbar'
import Icon from '../misc/Icons'
import EditorInsertButton from './EditorInsertButton'
import SetEditorMaxFreeLimitMessage from './SetEditorMaxFreeLimitMessage'
import SetEditorHelpDrawers from '../helpAssistants/SetEditorHelpDrawers'
import SaveStatusIndicator from './SaveStatusIndicator'
import PrintSetModal from './setEditorPrinting/modal/PrintSetModal' 

class SetEditorQuestionList extends React.PureComponent{
   
  
	render(){
		const {
			reorderQuestions,
			handleContextMenuClick,
			maxNumOfQuestionsReached,
			itemIsLockedByAnotherUser,
			isViewOnly
		}=this.props
			
		const copiedQuestion = JSON.parse(localStorage.getItem('copiedQuestion'))


	
		return[
				
			<QuestionListPanel 
				{...this.props}
				key={'QuestionListPanel'}
				updateOrder={reorderQuestions}
			/>,

			<ContextMenu key='contextMenu' id='QUESTION_SLIDE' className='contextMenu contextMenu--itemEditor' tabIndex='-1' zIndex='100'>
	      {!isViewOnly && 
	      	<React.Fragment>

	      		<MenuItem onClick={handleContextMenuClick} data={{action: 'NewQuestion'}} preventClose={true} disabled={maxNumOfQuestionsReached || itemIsLockedByAnotherUser}>					
					New Question					
				</MenuItem>

				<MenuItem divider/>

				<MenuItem onClick={handleContextMenuClick} data={{action: 'Cut'}} disabled={itemIsLockedByAnotherUser} preventClose={true}>					
					Cut					
				</MenuItem>

				<MenuItem onClick={handleContextMenuClick} data={{action: 'Copy'}} preventClose={true}>					
					Copy					
				</MenuItem>

				<MenuItem onClick={handleContextMenuClick} data={{action: 'Paste'}} preventClose={true} disabled={maxNumOfQuestionsReached || !copiedQuestion || itemIsLockedByAnotherUser}>					
					Paste					
				</MenuItem>

				<MenuItem onClick={handleContextMenuClick} data={{action: 'Duplicate'}} preventClose={true} disabled={maxNumOfQuestionsReached || itemIsLockedByAnotherUser}>					
					Duplicate					
				</MenuItem>	         	         
			         
			      <MenuItem divider/>	  

						<MenuItem onClick={handleContextMenuClick} data={{action: 'MoveUp'}} disabled={itemIsLockedByAnotherUser} preventClose={true}>					
							Move up					
						</MenuItem>

						<MenuItem onClick={handleContextMenuClick} data={{action: 'MoveDown'}} disabled={itemIsLockedByAnotherUser} preventClose={true}>					
							Move down					
						</MenuItem>

						<MenuItem divider/>

						<MenuItem onClick={handleContextMenuClick} data={{action: 'Delete'}} disabled={itemIsLockedByAnotherUser} attributes={{className:'is--warning'}} preventClose={true}>					
							Delete					
						</MenuItem>	  

	      	</React.Fragment>
	      }

	      {isViewOnly && 
	      	<MenuItem onClick={handleContextMenuClick} data={{action: 'Copy'}} preventClose={true}>					
			Copy					
			</MenuItem>
		}


			</ContextMenu>			
		]
	}
}


class SetEditor extends React.Component{

	constructor(props){
		super(props)
		this.updateOrder=this.updateOrder.bind(this)
		this.handleSelectQuestionCard=this.handleSelectQuestionCard.bind(this)
		this.handleChangeSubmit=this.handleChangeSubmit.bind(this)
		this.handleQuestionListKeyDown=this.handleQuestionListKeyDown.bind(this)
		this.handleChangeTemplate=this.handleChangeTemplate.bind(this)
		this.handleKeyPressNewQuestionButton=this.handleKeyPressNewQuestionButton.bind(this)


		let questions=null
		let activeQuestion=null

		if(props.set){
			questions=props.set.questions
			activeQuestion=props.activeQuestion
			
		}
 
		this.state={
      	  questions:questions,
      	  activeQuestion:activeQuestion,
      	  reorderingQuestions:false,
      	  height:0,
      	  width:0,
      	  transformScale:1,
      	  showPrintModal:false,

		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if(this.state.reorderingQuestions ===false){
			if (nextProps !== this.props) {
				if(nextProps.set){
					const activeQuestion= nextProps.activeQuestion
					this.setState({questions:nextProps.set.questions,activeQuestion:activeQuestion})
					
				}
			}
		}
		if(!this.props.itemIsLockedByAnotherUser && nextProps.itemIsLockedByAnotherUser){
			this.setState({showPrintModal:false})
		}


	}

 
	
	sizeChanged(dimensions){

		const height=dimensions.dimensions.height
		const width=dimensions.dimensions.width
		this.setState({height:height})
		this.setState({width:width})

		//transform scale for the whole slide
		let transformScale=1
		if(width && height) {
			if(width / 1.6 > height) {
				transformScale = height / 800
			} else {
				transformScale = width / 1280
			}
		}
		this.setState({transformScale:transformScale})
	}





	updateOrder(cards,newIndex){
		this.setState({reorderingQuestions:true})
		this.props.reorderQuestions(cards,newIndex)
	}

	handleSelectQuestionCard(newActiveQuestionIndex){
		this.props.changeActiveQuestion(newActiveQuestionIndex)
	}


	handleQuestionListKeyDown(e){
		this.props.handleQuestionListKeyDown(e)
	}


	handleChangeSubmit(value,field,index){
		this.props.editFormOnChange(value,field,index)
	}

	handleChangeTemplate(newTemplate){
		if(newTemplate==='right' && !this.props.hasImage){
			return null
		}	else{
			return this.props.changeTemplate(newTemplate)
		}
	}

	handleShuffleButtonKeyDown(e){
		if(e.keyCode===9){ //if press tab key focus on new questin button
			e.preventDefault()
			document.getElementById('addQuestionButton').focus()
		}
	}

	handleKeyPressNewQuestionButton(e){

		if(e.keyCode===13){ //if press tab key focus on new questin button
			e.preventDefault()
			this.props.newQuestionInSet()
		}else if(e.keyCode===9){
			e.preventDefault()
			const card=document.getElementById(this.state.activeQuestion.questionId)
			card.focus()
		}
	}



	renderItemEditorQuestionCanvas(){
		const {set}=this.props
		let hasEditedChoices //check if any of the choices have been edited
		if(set){
			const {activeQuestion}=this.state
			if(activeQuestion){
				hasEditedChoices=false		
				for (var i = 0; i < activeQuestion.choices.length; i++) {
					if(activeQuestion.choices[i].body !== '\u2063'){
						hasEditedChoices=true
					}
				}		
			}
			
	
			let transformScale = this.state.transformScale
			let slideWidth = transformScale * 1280
			let slideHeight = transformScale * 800			

			// const isLocked = false
			// const isLockedByYou = false

			const {isViewOnly,itemIsLockedByAnotherUser} = this.props
		
			return(
				<div className={'itemEditor-canvas itemEditor-canvas--setEditor ' + (!itemIsLockedByAnotherUser ? ' itemEditor-canvas--lockedByYou' : '') + (itemIsLockedByAnotherUser ? ' itemEditor-canvas--lockedByNotYou' : '')}>
					{!isViewOnly && 
						<EditorToolbar 
							{...this.props}
							activeQuestionIsSurvey={this.props.isSurvey} 
							questionTemplate={this.props.activeQuestionTemplate}
							activeQuestionHasImage={this.props.activeQuestionHasImage}
							isSet={true}
							itemIsLockedByAnotherUser={itemIsLockedByAnotherUser}
							setToGraded={this.props.setToGraded}
							setToSurvey={this.props.setToSurvey}
							handleChangeTemplate={this.handleChangeTemplate}
							hasImage={this.props.hasImage}
							canAddChoice={activeQuestion.choices.length < 4}
							maxNumOfQuestionsReached={this.props.maxNumOfQuestionsReached}
							
						/>
					}

					<Measure onMeasure={(dimensions) => {this.sizeChanged({dimensions})}}>
						<div className='itemEditor-canvas-slideLayoutContainer'>
							
							{activeQuestion &&
								
									<FormQuestionSlide
										{...this.props}
										isViewOnly={isViewOnly}
										updateFontSizes={this.props.updateFontSizes}
										handleBodyOnChange={this.props.handleBodyOnChange}
										handleChoiceOnChange={this.props.handleChoiceOnChange}
										template={activeQuestion.template}
										image={activeQuestion.image}
										updateBodyHeight={this.props.updateBodyHeight}
										question={activeQuestion} 
										choices={activeQuestion.choices}
										onChangeSubmit={this.handleChangeSubmit}
										transformScale={transformScale}
									/>
							} 

							{!isViewOnly && 
								<div className="itemEditor-canvas-controlsContainer" style={{width: `${slideWidth}px`, height: `${slideHeight}px`}}>
									<div className="itemEditor-canvas-controls--below">

										{hasEditedChoices && 
										<button onKeyDown={(e)=>{this.handleShuffleButtonKeyDown(e)}} className={'itemEditor-shuffleBtn btn btn--large btn--white ' + (this.props.isShuffling ? 'shuffleBtn--shuffling' : '')} disabled={itemIsLockedByAnotherUser} onClick={() =>{this.props.shuffleChoices()}} tabIndex={0}>
											<div className='itemEditor-shuffleBtn-shufflingIcon'/>
											<span className='itemEditor-shuffleBtn-label'>Shuffle Choices</span>											
										</button>
										}
										<div className='itemEditor-shuffleBtn-text-hint'>
													Press <strong>ENTER</strong> to Shuffle
										</div>
										{!hasEditedChoices && 
										<button onKeyDown={(e)=>{this.handleShuffleButtonKeyDown(e)}} onClick={()=>{this.props.setToTrueFalse()}} disabled={itemIsLockedByAnotherUser} className={'itemEditor-trueFalseBtn btn btn--large btn--white' + (!hasEditedChoices ? ' itemEditor-trueFalseBtn--show' : ' itemEditor-trueFalseBtn--hide' )} tabIndex={0}>
											Set as True/False
										</button>
										}



									</div>
									<div className="itemEditor-canvas-controls--right" style={{width: `calc((100vw - (${slideWidth}px)) / 2)`}}>
										{!this.props.disableImageSearch &&
											<div className="itemEditor-insertPanel">
												<EditorInsertButton label="Insert Image" isLocked={itemIsLockedByAnotherUser} icon="newImage" onClickFunction={() =>{this.props.showImageSearchModal()}} />
											</div>
										}
										{this.props.disableImageSearch &&
											<div className="itemEditor-insertPanel">																	
												<input 
													id='file'
													type='file'
													value={''}
													style={{position:'absolute', opacity: '0', height:'0', width: '0'}}
													name='uploadImage'
													onChange={this.props.handleFileUpload}
													accept=".png,.gif,.jpg,.jpeg,.tif,.tiff"
													disabled={itemIsLockedByAnotherUser || isViewOnly}
												/>							     
												<label htmlFor='file'>
													<EditorInsertButton label="Insert Image" icon="newImage" />
												</label>
										
											</div>
										}



									</div>
								</div>			
							}
						</div>


					</Measure>
				  			  	
				</div>

			)
		}
	}


	render(){
		const set = this.props.set
		let setName = '-'
		if(set){
			setName=set.name
		}

		let isPublicConsumer = false
		if(this.props.parentRepo && this.props.parentRepo.role === 'consumer'){
			isPublicConsumer = true
		}

		let isPublicAuthor = false
		if(this.props.parentRepo && this.props.parentRepo.role === 'author'){
			isPublicAuthor = true
		}
		
		//const isLocked = this.props.isLockedToCurrentUser
		const {isViewOnly,itemIsLockedByAnotherUser} = this.props

		return(
			<div className={'itemEditor itemEditor--setEditor' + (itemIsLockedByAnotherUser ? ' itemEditor--setEditor--lockedByNotYou' : '') + (isViewOnly ? ' itemEditor--setEditor--isViewOnly' : '')}>
				<EditorTopBar
					{...this.props}
					openPrintModal={()=>{this.setState({showPrintModal:true})}}
					item={set || {}}
					isSet={true}
					title={setName}
					isPublicAuthor={isPublicAuthor}
					isPublicConsumer={isPublicConsumer}
					itemIsLockedByAnotherUser={itemIsLockedByAnotherUser}
					archiveItem={this.props.archiveSet}
					newQuestionInSet={this.props.newQuestionInSet}
					handleKeyPressNewQuestionButton={this.handleKeyPressNewQuestionButton}
					maxNumOfQuestionsReached={this.props.maxNumOfQuestionsReached}
					isViewOnly={isViewOnly}
					showRepoSelectionModal={this.props.showRepoSelectionModal}
					showImportQuestionsModal={this.props.showImportQuestionsModal}
				/>
				
				<div className='itemEditor-content'>
					<div className='itemEditor-leftPanel'>						
						<SetEditorQuestionList 
							{...this.props}
							itemIsLockedByAnotherUser={itemIsLockedByAnotherUser}
							isViewOnly={isViewOnly}
							questionList={this.state.questions} 
							selectQuestionCard={this.handleSelectQuestionCard}
							handleQuestionListKeyDown={this.handleQuestionListKeyDown}
						/>						
						{this.props.questionsInSetLimit && !isPublicConsumer &&
							<SetEditorMaxFreeLimitMessage 
								displayMessage={this.props.maxNumOfQuestionsReached}
							/> 	
						}	
						
						
					</div>
					{this.props.currentSet &&
						<SaveStatusIndicator
							item={this.props.currentSet}
							parentRepo={this.props.parentRepo}
							isSaving={this.props.isSaving}
							unableToSave={this.props.unableToSave}
							itemIsLockedByAnotherUser={itemIsLockedByAnotherUser}
							lastEditedBy={this.props.currentSet.lastEditedBy}
							lock={this.props.lock} 
							permissions={this.props.permissions}
						/>
					}	

					{this.props.isViewOnly && !isPublicConsumer &&
						<div className='itemEditor-viewOnlyBanner'>							
							<Icon name='eye'/> View only
						</div>
					}

					<SetEditorHelpDrawers
						isViewOnly={isViewOnly}						
					/>

					{this.renderItemEditorQuestionCanvas()}					
				</div>	
				{this.state.showPrintModal &&
					<PrintSetModal set={set} closePrintSetModal={()=>{this.setState({showPrintModal:false})}} />
				}
			</div>
		)
	}
}





SetEditor.propTypes = {
	set: PropTypes.object,
	activeQuestion: PropTypes.object,
}



export default SetEditor






